import { BaseEntity } from 'yt-ng-framework';


export class SistRadnihMesta extends BaseEntity {
    constructor() {
        super();
    }
    RadnoMestoID: number = null;
    OrgJedID: number = null;
    broj_izvrsilaca: number = null;


    Deserialize(input: any) {
        this.ID = input.ID;
        this.RadnoMestoID = input.RadnoMestoID;
        this.OrgJedID = input.OrgJedID;
        this.broj_izvrsilaca = input.broj_izvrsilaca;
        return this;
    }

    Serialize(input: SistRadnihMesta) {
        return input;
    }
}
